import { render, staticRenderFns } from "./SuccessReceive.vue?vue&type=template&id=06bb25a9&"
import script from "./SuccessReceive.vue?vue&type=script&lang=js&"
export * from "./SuccessReceive.vue?vue&type=script&lang=js&"
import style0 from "./SuccessReceive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports